/**
 * @ben Quote.initialLoad(this.props.fieldName) will get you the application cache value back
 */

import React from 'react';
import DatePicker from 'react-datepicker';
import HelpIcon from './HelpIcon';
import HelpText from './HelpText';
import FieldValidation  from '../Fragments/FieldValidation';
import FieldError       from '../Fragments/FieldError';
import moment from 'moment';

import 'react-datepicker/dist/datepicker.min.css';
let Quote = require('../Managers/Quote.js');

const CalendarInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        question:  React.PropTypes.string.isRequired,
        dateFormat: React.PropTypes.string,
        helpText:   React.PropTypes.string,
        minDate:    React.PropTypes.object,
        maxDate:    React.PropTypes.object,
    },

    getDefaultProps: function() {
        return {
            dateFormat: 'DD/MM/YYYY',
            minDate: moment(),
            maxDate: moment().add(45, 'days')
        };
    },
    getInitialState: function() {
        return {
            startDate: null,
            isHelpVisible: false,
            isMobile: (window.innerWidth < 415) ? true : false,
            hasError: false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
        };
    },
    componentWillMount() {
        let cd = Quote.getCurrentAnswer(this.props.fieldName);
        if (cd !== null && cd !== undefined) {
            this.setState({
                startDate: moment(cd, 'DD/MM/YYYY'),
            });
        }
    },
    resetState() {
        this.setState(this.getInitialState());
    },
    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }

        this.setState({
            hasError : false,
            errors : []
        });

        return true;
    },
    handleChange(date) {
        this.setState({
            startDate: date,
            isValid: true
        });
        Quote.set(this.props.fieldName, moment(date).format(this.props.dateFormat));
    },

    makeToday: function() {
        let tday = moment();
        this.handleChange(tday);
        this.doValidation();
    },

    makeTomorrow: function() {
        let tmoz = moment().add(1, 'day');
        this.handleChange(tmoz);
        this.doValidation();
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true
        });
    },

    render: function() {
        let currentDate = moment().format(this.props.dateFormat);
        let tomorrowDate = moment().add(1, 'days').format(this.props.dateFormat);
        let startDateSet = Quote.getCurrentAnswer(this.props.fieldName);
        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';

        return (
            <question-row>
                <div className="question-main">
                    <div className={topClass}>
                        <label>{this.props.question}</label>
                        <HelpIcon onClick={this.toggleHelpText} />
                    </div>
                    <div className="question-input">
                        <div className="datepicker">
                            <div className="desktop-date-picker-wrapper">
                                <div className="desktop-date-picker-element">
                                    <DatePicker
                                        dateFormat={this.props.dateFormat}
                                        minDate={this.props.minDate}
                                        maxDate={this.props.maxDate}
                                        className="form-control"
                                        id={this.props.fieldName}
                                        readOnly={true}
                                        onChange={this.handleChange}
                                        selected={this.state.startDate}
                                        onBlur={this.onBlur}
                                    />
                                </div>
                                <div className="desktop-date-picker-element manual-date-setter">
                                    <button
                                        className={startDateSet == currentDate ? 'btn btn-default enabled' : 'btn btn-default'}
                                        onClick={this.makeToday.bind(null, this)}
                                    >
                                        Today
                                    </button>
                                </div>
                                <div className="desktop-date-picker-element manual-date-setter">
                                    <button
                                        onClick={this.makeTomorrow.bind(null, this)}
                                        className={startDateSet == tomorrowDate ? 'btn btn-default enabled' : 'btn btn-default'}
                                    >
                                        Tomorrow
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <HelpText text={this.props.helpText} active={this.state.isHelpVisible} />
                    {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                </div>
                <div className="question-extra">
                    <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                </div>
            </question-row>
        );
    }
});

export default CalendarInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/CalendarInput.js
 **/